/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import StatusIcon from 'app/components/challenge/StatusIcon';

type Props = {
  checked?: boolean,
  children: any,
  onChange: (boolean) => void,
  statusId: number,
};

const defaultProps = {
  checked: false,
};

const StatusCheckButtonWrapper = glamorous.div({
  display: 'block',
  position: 'relative',
});

const Button = glamorous('button', {
  withProps: {
    type: 'button',
  },
})(({ theme }) => ({
  alignItems: 'center',
  background: 'none',
  borderRadius: 3,
  borderColor: theme.color.basis2,
  borderStyle: 'solid',
  borderWidth: 2,
  color: theme.color.basis2,
  display: 'flex',
  justifyContent: 'center',
  padding: '0.375em 0.125em',
  textAlign: 'center',
  textTransform: 'uppercase',
  transitionDuration: '0.2s',
  width: '100%',
}), ({ checked, theme }) => (
  checked ? {
    backgroundColor: theme.color.basis2,
    borderColor: theme.color.basis2,
    color: theme.color.white,
  } : {
    '&:hover': {
      backgroundColor: theme.color.white,
      color: theme.color.basis2,
    },
  }
));

const IconWrapper = glamorous.div(({ theme }) => ({
  backgroundImage: `linear-gradient(135deg, ${theme.color.basis2} 50%, transparent 50%)`,
  color: 'white',
  left: 0,
  height: '2em',
  paddingLeft: 2,
  paddingTop: 1,
  position: 'absolute',
  top: 0,
  width: '2em',
}));

function StatusCheckButton({
  checked,
  children,
  onChange,
  statusId,
}: Props) {
  return (
    <StatusCheckButtonWrapper>
      <IconWrapper>
        <StatusIcon statusId={statusId} />
      </IconWrapper>
      <Button checked={checked} onClick={() => onChange(!checked)}>
        {children}
      </Button>
    </StatusCheckButtonWrapper>
  );
}

StatusCheckButton.defaultProps = defaultProps;

export default StatusCheckButton;
